import React from 'react';
import { Switch, Route } from 'react-router-dom';
import DesempenoContainer from './Desempeno';
import { ModalDispatcher } from './Modals/modalDispatcher';

function Desempeno() {
  return (
    <>
      <ModalDispatcher />
      <Switch>
        <Route path='/desempeno'>
          <DesempenoContainer />
        </Route>
      </Switch>
    </>
  );
}

export { Desempeno };
